fx.ns("shared.extractors", class StickerExtractor extends shared.MediaExtractor {

    constructor(parameters)
    {
        super(parameters);
    }

    process(data, theme_category)
    {
        this._theme_category = theme_category;

        super.process(data);
    }

    onImageExtracted(data)
    {
        let date = new Date();

        let sticker = new models.Sticker({
            theme_category_id : this._theme_category.id,
            keywords : "",
            visible : 1,
            thumb : data.thumb,
            light_url : data.blob,
            width : data.width,
            height : data.height,
            id_lang : fx.service("LangService").current.id
        });

        //sticker.prop("thumb", data.thumb);
        //sticker.update({"thumb" : data.thumb});
        sticker.prop("blob", data.blob);

        sticker.prop("date", date);
        
        if (fx.get("app") == "config")
            sticker.prop("file", data.file); 
        //sticker.prop("memory", data.image); 
        sticker.prop("slug", this._theme_category.slug); 
        

        this.data.addItem(sticker);

        this.trigger("sticker-extracted", sticker);
    }
   
    

});